var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C10.9091 8 3.14545 13.1738 0 20.4771C3.14545 27.7803 10.9091 32.9541 20 32.9541C29.0909 32.9541 36.8545 27.7803 40 20.4771C36.8545 13.1738 29.0909 8 20 8ZM20 28.7951C14.9818 28.7951 10.9091 25.0686 10.9091 20.4771C10.9091 15.8855 14.9818 12.159 20 12.159C25.0182 12.159 29.0909 15.8855 29.0909 20.4771C29.0909 25.0686 25.0182 28.7951 20 28.7951ZM20 15.4862C16.9818 15.4862 14.5455 17.7155 14.5455 20.4771C14.5455 23.2387 16.9818 25.4679 20 25.4679C23.0182 25.4679 25.4545 23.2387 25.4545 20.4771C25.4545 17.7155 23.0182 15.4862 20 15.4862Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon_Eye.4ffcadc8e49eb804f2a07914d78adde1.svg";
export { ForwardRef as ReactComponent };